import React, { useCallback } from 'react';

import updateMediaElementOperation, {
  MediaUpdateActionName,
} from 'editor/src/store/design/operation/updateMediaElementOperation';
import { Coords, ElementAddress } from 'editor/src/store/design/types';
import { useDispatch } from 'editor/src/store/hooks';

import CustomFabricRect from 'editor/src/fabric/CustomFabricRect';
import useFabricUtils from 'editor/src/util/useFabricUtils';

import fabricPropsToRectangleElementData from './fabricPropsToRectangleElementData';

function useRectangleUpdates(
  pageCoords: Coords,
  elementAddress: ElementAddress,
  rectangleRef: React.RefObject<CustomFabricRect>,
) {
  const dispatch = useDispatch();
  const { px2mm } = useFabricUtils();

  const onObjectModified = useCallback(() => {
    if (rectangleRef.current) {
      const rectangleUpdate = fabricPropsToRectangleElementData(px2mm, pageCoords, rectangleRef.current);
      dispatch(
        updateMediaElementOperation(elementAddress, rectangleUpdate, MediaUpdateActionName.RECTANGLE_POSITION_UPDATED),
      );
    }
  }, [px2mm, pageCoords, elementAddress]);

  return { onObjectModified };
}

export default useRectangleUpdates;
